
import Vue from 'vue'
import EventForm from '@/components/EventForm.vue'
import EventMap from '@/components/EventMap.vue'
import FMEventList from '@/components/FMEventList.vue'
import FocalMechanismResult from '@/components/FocalMechanismResult.vue'
import { BeachballEngine } from '@/utils'
import { SismoazurEventParameter } from '@/types'

export default Vue.extend({
  components: {
    EventForm,
    EventMap,
    FMEventList,
    FocalMechanismResult
  },

  props: {
    flag: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      ready: false,
      fmModal: false,
      fmModalEvent: null as SismoazurEventParameter | null,
      formActive: false,
      infoActive: false,
      showMap: false,
      beachballEngine: new BeachballEngine(50, 40, 1.5, `${location.href.split('#')[0]}static/wasm/beachball.wasm`)
    }
  },

  mounted () {
    this.loadEvents()
  },

  watch: {
    flag: function (value) {
      // this.$store.dispatch('fmParams', { mode: true, filter: this.flag })
      this.loadEvents()
    },
    '$store.state.events': function (value) {
      console.log('ready')
      this.ready = true
    }
  },

  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('clearEvents')
    this.$store.dispatch('fmParams', { mode: false, filter: null })
    next()
  },

  methods: {
    getExtraArgs () {
      const now = new Date()
      return this.flag === 'oca'
        ? {
            minlon: -90,
            maxlon: 90,
            minlat: -180,
            maxlat: 180,
            starttime: '1960-01-01',
            endtime: new Date(now.getTime() + 86400e3).toISOString().split('T')[0]
          }
        : {
            minlat: -90,
            maxlat: 90,
            minlon: -180,
            maxlon: 180,
            starttime: new Date(now.getTime() - 182 * 86400e3).toISOString().split('T')[0], // last 6 months
            endtime: new Date(now.getTime() + 86400e3).toISOString().split('T')[0]
          }
    },
    loadEvents () {
      this.$store.dispatch('fmParams', { mode: true, filter: this.flag })
      this.$store.dispatch('loadEvents', Object.assign({
        format: 'xml',
        requirefocalmechanism: 'true',
        includeallmagnitudes: 'true',
        catalog: this.flag === 'oca' ? 'FM(OCA)' : 'FM(EMSC)'
      }, this.getExtraArgs()))
    },
    handleSubmit (query: Record<string, string>) {
      this.ready = false
      this.$store.dispatch('loadEvents', Object.assign({
        format: 'xml',
        requirefocalmechanism: 'true',
        includeallmagnitudes: 'true'
      }, query))
    },
    handleFmModalRequest (event: SismoazurEventParameter) {
      this.fmModalEvent = event
      this.fmModal = true
    }
  }
})
